import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { authenticated, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!authenticated) {
    // Signed-out visitors land on the marketing page, not the Keycloak
    // login bounce. The CTAs there call kc.login() when they're ready.
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
